
if (!customElements.get('ly-popover-v5')) {
    customElements.define('ly-popover-v5', class extends HTMLElement {

        get visible() {
            return this.input.checked
        }

        connectedCallback() {
            this.render()

            this.input = this.querySelector('input.ly-popover-v5-checkbox')

            this.rootDom = document.querySelector(`.ly-popover-v5[data-popover-id="${this.dataset.popoverId}"]`)
            this.mask = this.rootDom.querySelector('.ly-popover-v5-mask')
            this.bodyContent = this.rootDom.querySelector(`.ly-popover-v5-body-wrapper`)

            this.input.addEventListener('change', this.handleVisiblityChange)

            requestAnimationFrame(() => {
                this.handleVisiblityChange()
            })

            this.mask.addEventListener('click', this.handleClickMask)
        }

        disconnectedCallback() {
            this.input.removeEventListener('change', this.handleVisiblityChange)
            this.mask.removeEventListener('click', this.handleClickMask)
        }

        render = () => {
            const template = this.querySelector('template')
            document.body.appendChild(template.content)
            template.remove()
        }

        handleVisiblityChange = () => {
            this.syncState()
            this.dispatchVisibilityChangeEvent()
        }

        syncState = () => {

            const gorgias = document.querySelector('#gorgias-chat-container')
            if (gorgias) {
                gorgias.style.display = this.visible ? 'none' : 'block'
            }

            if (this.visible) {
                this.rootDom.classList.remove('ly-hide')
                this.rootDom.querySelector('.ly-popover-v5-container')?.scrollTo({
                    top: 0,
                    behavior: 'instant'
                })
                setTimeout(() => {
                    this.rootDom.classList.add('is-visible')
                }, 0)
            } else {
                this.rootDom.classList.remove('is-visible')
                setTimeout(() => {
                    this.rootDom.classList.add('ly-hide')
                }, 300)
            }
        }

        dispatchVisibilityChangeEvent = () => {
            this.dispatchEvent(new CustomEvent('visibility_change', {
                detail: {
                    visible: this.visible
                }
            }))

            window.publish('bus:popover_v5_visibility_changed', {
                visible: this.visible,
                popover: this
            })
        }

        open = () => this.changeVisiblity(true)

        close = () => this.changeVisiblity(false)

        changeVisiblity = visible => {
            this.input.checked = visible
            this.input.dispatchEvent(new Event('change', {
                bubbles: true
            }))
        }

        handleClickMask = (evt) => {
            if (evt.target === this.mask) {
                evt.preventDefault()
                evt.stopPropagation()
                this.close()
            }
        }
    })
}
